import { render, staticRenderFns } from "./TSZ_Resetear.vue?vue&type=template&id=4c1a7d0d&"
import script from "./TSZ_Resetear.vue?vue&type=script&lang=js&"
export * from "./TSZ_Resetear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports